// @mui
import { Box, Chip, emphasize, styled } from "@mui/material";

// ---------------------------------Global Styles-------------------------------------

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
      {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const StyledBreadcrumb = styled(Chip)(({ theme }: any) => {
  const backgroundColor = theme.palette.mode === "light" ? theme.palette.primary[200] : theme.palette.primary[800];
  return {
    backgroundColor: "transparent",
    height: theme.spacing(3),
    borderRadius: 5,
    // color: theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: "transparent",
      // backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      // boxShadow: theme.shadows[1],
      // backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;
